export const catchError = (ex, onError) => (dispatch) => {
  if (ex.response) {
    ex.response.json().then((error) => dispatch(onError(error)));
  } else {
    console.log(ex);
    dispatch(onError(ex));
  }
};
